import { useRef, useState, useEffect } from "react";
import "./Whysection.css";

const whyData = [
  {
    title: "Quality service",
    desc: "Every deliverable goes through rigorous quality checks before it reaches you.",
    color: "#ff1744",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ),
  },
  {
    title: "Experienced team",
    desc: "Industry veterans with 10+ years across diverse tech domains.",
    color: "#1a9fd4",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="7" r="4"/>
        <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        <path d="M21 21v-2a4 4 0 0 0-3-3.85"/>
      </svg>
    ),
  },
  {
    title: "Fast delivery",
    desc: "Agile sprints keep projects on time without cutting corners.",
    color: "#ff1744",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
  },
  {
    title: "Modern technologies",
    desc: "We stay ahead — React, Next.js, Flutter, AI/ML and beyond.",
    color: "#1a9fd4",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <path d="M8 21h8M12 17v4"/>
      </svg>
    ),
  },
  {
    title: "Client support",
    desc: "24×7 dedicated support so you're never left in the dark.",
    color: "#ff1744",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.35 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 5.55 5.55l.92-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21 16.92z"/>
      </svg>
    ),
  },
];

function useInView(threshold = 0.1) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export default function WhySection() {
  const [sectionRef, sectionIn] = useInView(0.1);

  return (
    <section className="why-section" id="why" ref={sectionRef}>

      {/* Header */}
      <div className={`why-header${sectionIn ? " why-header--in" : ""}`}>
        <span className="why-eyebrow">Our strengths</span>
        <h2 className="why-heading">
          Why we are the <span className="why-heading-accent">top choice</span>
        </h2>
        <p className="why-subtext">
          Five pillars that make every engagement with SkillSync Pro exceptional.
        </p>
      </div>

      {/* Steps row */}
      <div className={`why-steps${sectionIn ? " why-steps--in" : ""}`}>
        {whyData.map((w, i) => (
          <div
            className="why-step"
            key={w.title}
            style={{ transitionDelay: `${i * 0.1}s` }}
          >
            <div className="why-step__icon-wrap">
              <div className="why-step__icon" style={{ background: w.color }}>
                {w.icon}
              </div>
              <span className="why-step__num" style={{ borderColor: w.color, color: w.color }}>
                {i + 1}
              </span>
              {i < whyData.length - 1 && <div className="why-step__connector" />}
            </div>
            <h3 className="why-step__title">{w.title}</h3>
            <p className="why-step__desc">{w.desc}</p>
          </div>
        ))}
      </div>

    </section>
  );
}